import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
var Video = styled.video.attrs(function () {
  return {
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: false
  };
}).withConfig({
  displayName: "VideoBanner__Video",
  componentId: "wxn2ep-0"
})(["width:100%;height:100%;"]);

var VideoBanner = function VideoBanner(_ref) {
  var video = _ref.video,
      poster = _ref.poster;
  var videoEl = useRef(null);

  var onPlay = function onPlay() {
    videoEl.current.play();
  };

  useEffect(function () {
    onPlay();
  });
  return React.createElement(Video, {
    poster: poster,
    src: video,
    ref: videoEl
  }, "Your browser does not support video.");
};

export default VideoBanner;